const api = (window.__webadb__ = window.__webadb__ || {
  ping() { console.log("[bridge] alive"); return { ok: true }; }
});

import { Adb, AdbDaemonTransport } from "@yume-chan/adb";
import { AdbDaemonWebUsbDeviceManager } from "@yume-chan/adb-daemon-webusb";
import AdbWebCredentialStore from "@yume-chan/adb-credential-web";

let __dev = null;          // AdbDaemonWebUsbDevice
let __connection = null;   // duplex-потоки после device.connect()
let __transport = null;    // AdbDaemonTransport
let __adb = null;          // Adb (high-level)

function isSupported() {
  return !!AdbDaemonWebUsbDeviceManager.BROWSER;
}

function isConnected() {
  return !!__adb;
}

async function requestDeviceAndConnect() {
  try {
    if (!isSupported()) {
      return { error: "WebUSB unsupported (Chrome/Edge + HTTPS или http://localhost)" };
    }

    if (__adb) {
      return { error: null };
    }

    const device = await AdbDaemonWebUsbDeviceManager.BROWSER.requestDevice();
    if (!device) return { error: "cancelled" };

    __dev = device;
    __connection = await device.connect();

    const credentialStore = new AdbWebCredentialStore("Kotlin/Wasm key");
    __transport = await AdbDaemonTransport.authenticate({
      serial: "webusb",
      connection: __connection,
      credentialStore,
    });

    __adb = new Adb(__transport);
    return { error: null };
  } catch (e) {
    const msg = e && e.message ? e.message : String(e);
    console.warn("[webadb] connect error:", msg);
    return { error: msg };
  }
}

async function shell(cmd) {
  try {
    if (!__adb) return { out: "", error: "ADB not connected" };

    if (__adb.subprocess.shellProtocol) {
      const { stdout, exitCode } = await __adb.subprocess.shellProtocol.spawnWaitText(cmd);
      // если команда вернулась с кодом != 0 — считаем это ошибкой, но отдаём и out
      const err = (typeof exitCode === "number" && exitCode !== 0) ? `exitCode=${exitCode}` : null;
      return { out: stdout ?? "", error: err };
    }

    const stdout = await __adb.subprocess.noneProtocol.spawnWaitText(cmd);
    return { out: stdout ?? "", error: null };
  } catch (e) {
    const msg = e && e.message ? e.message : String(e);
    return { out: "", error: msg };
  }
}

async function deviceInfo() {
  try {
    if (!__adb) return { ok: false, error: "ADB not connected", brand: "", model: "", android: "", sdk: "" };

    const read = async (p) => {
      const r = await api.shell(`getprop ${p}`);
      if (r.error) throw new Error(`getprop ${p}: ${r.error}`);
      return (r.out || "").trim();
    };

    const brand = await read("ro.product.brand");
    const model = await read("ro.product.device");
    const android = await read("ro.build.version.release");
    const sdk = await read("ro.build.version.sdk");

    return { error: null, brand, model, android, sdk };
  } catch (e) {
    const msg = e && e.message ? e.message : String(e);
    return { error: msg, brand: "", model: "", android: "", sdk: "" };
  }
}

async function disconnect() {
  try {
    try { await __adb?.close?.(); } catch (_) { }
    __adb = null;

    try { await __transport?.close?.(); } catch (_) { }
    __transport = null;

    try { await __connection?.close?.(); } catch (_) { }
    __connection = null;

    try { await __dev?.close?.(); } catch (_) { }
    try { await __dev?.dispose?.(); } catch (_) { }
    __dev = null;

    return { error: null };
  } catch (e) {
    const msg = e && e.message ? e.message : String(e);
    return { error: msg };
  }
}

async function installApkFromUrl(url) {
  try {
    if (!__adb) return { error: "ADB not connected" };
    if (!url) return { error: "url is required" };

    let blob;
    try {
      const resp = await fetch(url, { mode: "cors" });
      if (!resp.ok) return { error: `download failed: ${resp.status} ${resp.statusText}` };
      blob = await resp.blob();
    } catch (e) {
      return { error: "CORS or network error: " + (e?.message || e) };
    }

    const size = blob.size;
    if (__adb.subprocess?.shellProtocol && size > 0) {
      const proc = await __adb.subprocess.shellProtocol.spawn(`cmd package install -S ${size}`);
      const writer = proc.stdin.getWriter();
      const reader = blob.stream().getReader();
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        if (value) await writer.write(value);
      }
      await writer.close();

      const dec = new TextDecoder();
      let out = "";
      for await (const chunk of proc.stdout) out += dec.decode(chunk, { stream: true });
      console.log(out);
      if (out.trim() == "Success") {
        return { error: null };
      } else {
        return { error: out };
      }
    }
  } catch (e) {
    const msg = e && e.message ? e.message : String(e);
    return { ok: false, error: msg };
  }
}

api.isSupported = isSupported;
api.isConnected = isConnected;
api.requestDeviceAndConnect = requestDeviceAndConnect;
api.shell = shell;
api.deviceInfo = deviceInfo;
api.disconnect = disconnect;
api.installApkFromUrl = installApkFromUrl;
